import styled from "styled-components";
import { useEffect, useState } from "react";
import PanelAreaFieldList from "./PanelAreaFieldList";
import PanelAreasNav from "./PanelAreasNav";
import { AreaSource, PlaySource } from "type/panel/Panel.type";
import PanelAreaSourceNav from "./PanelAreaSourceNav";
import { PANEL_AREA_SOURCE_NAV_MODES } from "./PanelAreaSourceNav/PanelAreaSourceNav.const";
import {
  areaDeleteInd,
  areaInitialAdd,
  areaSourceUpdate,
} from "./PanelAreas.logic";

type PanelAreasProps = {
  defaultAreas: AreaSource[];
  onAreasUpdate: Function;
};

const PanelAreas = ({ defaultAreas, onAreasUpdate }: PanelAreasProps) => {
  const [sourceType, setSourceType] = useState<string>("");
  const [areas, setAreas] = useState<AreaSource[]>([...defaultAreas]);
  const [selectedAreaInd, setSelectedAreaInd] = useState<number | null>(null);
  const [navMode, setNavMode] = useState<string>(
    PANEL_AREA_SOURCE_NAV_MODES.CONTENT
  );

  useEffect(() => {
    onAreasUpdate(areas);
  }, [areas]);

  const sourceTypeChange = (ev: any) => {
    console.log("sourceTypeChange", ev.target.value);
    setSourceType(ev.target.value);
  };

  const newAreaHandle = () => {
    const areasNext: AreaSource[] = areaInitialAdd(areas);
    setAreas(areasNext);
  };

  const deleteAreaHandle = async () => {
    if (selectedAreaInd !== null) {
      const areasNext: AreaSource[] = areaDeleteInd(areas, selectedAreaInd);
      setSelectedAreaInd(null);
      setAreas(areasNext);
    }
  };

  const selectAreaHandle = (ind: number) => {
    setSelectedAreaInd(ind);
    console.log("selectAreaHandle", ind);
  };

  const deselectAreaHandle = () => {
    setSelectedAreaInd(null);
    console.log("deselectAreaHandle");
  };

  const areasUpdateHandle = (areasUpdated: AreaSource[]) => {
    setAreas(areasUpdated);
  };

  const sourceUpdateHandle = (sourceUpdated: PlaySource[]) => {
    if (selectedAreaInd !== null) {
      const areasUpdated: AreaSource[] = areaSourceUpdate(
        areas,
        selectedAreaInd,
        sourceUpdated
      );
      setAreas(areasUpdated);
    }
  };

  return (
    <div>
      <DivAreasNav>
        <PanelAreasNav
          areas={areas}
          onNewArea={newAreaHandle}
          onDeleteArea={deleteAreaHandle}
          onSelectArea={selectAreaHandle}
          onDeselectArea={deselectAreaHandle}
        />
      </DivAreasNav>
      <DivAreas>
        <PanelAreaFieldList
          areas={areas}
          selectedAreaInd={selectedAreaInd}
          onAreasUpdate={areasUpdateHandle}
        />
      </DivAreas>
      {selectedAreaInd !== null && (
        <DivAreaSource>
          <PanelAreaSourceNav
            source={areas[selectedAreaInd].source}
            onSourceUpdate={sourceUpdateHandle}
            navMode={navMode}
            setNavMode={setNavMode}
          />
        </DivAreaSource>
      )}
    </div>
  );
};

const DivAreas = styled.div`
  display: grid;
  width: 36rem;
  height: 24rem;
  border: 0px solid green;
  margin-top: 0.5rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0.2rem 0.2rem;
`;

const DivAreasNav = styled.div`
  display: flex;
  width: 100%;
`;

const DivAreaSource = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1rem;
`;

export default PanelAreas;
